import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistBio = (artist) => {
  return axios.get(URL_PREFIX + '/artist-bios/' + artist + '/')
}

export const postArtistBio = (param) => {
  return axios.post(URL_PREFIX + '/artist-bios/', param)
}

export const patchArtistBio = (artist, param) => {
  return axios.patch(URL_PREFIX + '/artist-bios/' + artist + '/', param)
}
